"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ObjectId = require('bson').ObjectID;
var tv4 = require('tv4');
var InventoryReference = require('./inventory-reference');
var ColleagueRequest = /*#__PURE__*/function () {
  function ColleagueRequest(opt) {
    _classCallCheck(this, ColleagueRequest);
    this._id = null;
    this.requestedBy = null;
    this.approvedBy = null;
    this.status = null;
    if (opt) {
      this.fillObject(opt);
    }
  }
  _createClass(ColleagueRequest, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.requestedBy = new InventoryReference(opt.requestedBy);
      this.approvedBy = new InventoryReference(opt.approvedBy);
      this.status = opt.status || 'PENDING';
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, ColleagueRequest.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'colleague-request.schema.json',
        type: 'object',
        properties: {
          _id: {
            type: 'object'
          },
          requestedBy: {
            $ref: 'inventory-reference.schema.json'
          },
          approvedBy: {
            $ref: 'inventory-reference.schema.json'
          },
          status: {
            type: 'string'
          }
        },
        required: ['_id', 'requestedBy', 'approvedBy', 'status']
      };
    }
  }]);
  return ColleagueRequest;
}();
tv4.addSchema(InventoryReference.schema());
module.exports = ColleagueRequest;